import React, { useState, useEffect } from "react";
import { FormFeedback, Tooltip } from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from 'date-fns';

const DatePickerInput = ({
    label = "Select Date",
    placeholder = "Select a date",
    required = false,
    layout = "below",
    name = "datePicker",
    value = null,
    onChange = () => {}, // Updated to match Formik
    onBlur = () => {},
    requiredErrorMessage = "Please select a date.",
    rangeErrorMessage = (minDate, maxDate) => `Please select a date between ${minDate} and ${maxDate}.`,
    showHelp = false,
    helpText = "Please select a date.",
    dateRange = { minDate: null, maxDate: null },
    validateTrigger = false
}) => {
    const [selectedDate, setSelectedDate] = useState(value);
    const [errors, setErrors] = useState({});
    const [tooltipOpen, setTooltipOpen] = useState(false);

    useEffect(() => {
        setSelectedDate(value);
    }, [value]);

    useEffect(() => {
        if (validateTrigger) {
            validateDate(selectedDate);
        }
    }, [validateTrigger, selectedDate]);

    const handleDateChange = (date) => {
        setSelectedDate(date);
        validateDate(date);

        // Directly call Formik's setFieldValue through onChange
        onChange(name, date ? format(date, "yyyy-MM-dd") : "");
    };

    const handleDateBlur = () => {
        validateDate(selectedDate);
        onBlur(name);
    };

    const validateDate = (date) => {
        const newErrors = {};
        if (required && !date) {
            newErrors.required = requiredErrorMessage;
        } else if (dateRange.minDate && date < dateRange.minDate) {
            newErrors.range = rangeErrorMessage(
                dateRange.minDate.toLocaleDateString(),
                dateRange.maxDate ? dateRange.maxDate.toLocaleDateString() : "infinity"
            );
        } else if (dateRange.maxDate && date > dateRange.maxDate) {
            newErrors.range = rangeErrorMessage(
                dateRange.minDate ? dateRange.minDate.toLocaleDateString() : "negative infinity",
                dateRange.maxDate.toLocaleDateString()
            );
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    return (
        <div className={`form-group ${layout === "inline" ? "d-flex align-items-center" : ""}`}>
            <label
                className="d-flex"
                style={{ width: layout === "inline" ? "20%" : "100%" }}
            >
                <span>
                    {label}
                    {required && <span className="text-danger ml-1">*</span>}
                </span>
                {showHelp && (
                    <span id="helpTooltip" className="px-2">
                        <i
                            className="ri-question-line"
                            style={{ cursor: "pointer", fontSize: "16px" }}
                        ></i>
                    </span>
                )}
            </label>
            {showHelp && (
                <Tooltip
                    placement="right"
                    isOpen={tooltipOpen}
                    target="helpTooltip"
                    toggle={() => setTooltipOpen(!tooltipOpen)}
                >
                    {helpText}
                </Tooltip>
            )}
            <div className="w-100">
                <DatePicker
                    showIcon
                    selected={selectedDate}
                    onChange={handleDateChange}
                    onBlur={handleDateBlur}
                    placeholderText={placeholder}
                    minDate={dateRange.minDate}
                    maxDate={dateRange.maxDate}
                    isClearable
                    className={`form-control full-width ${
                        errors.required || errors.range ? "is-invalid" : ""
                    }`}
                />
                {errors.required && (
                    <FormFeedback className="d-block" type="invalid">
                        {errors.required}
                    </FormFeedback>
                )}
                {errors.range && (
                    <FormFeedback className="d-block" type="invalid">
                        {errors.range}
                    </FormFeedback>
                )}
            </div>
        </div>
    );
};

export default DatePickerInput;



// import React, { useState, useEffect } from "react";
// import { FormFeedback, Tooltip } from "reactstrap";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";

// const DatePickerInput = ({
//     label = "Select Date",
//     placeholder = "Select a date",
//     required = false,
//     layout = "below",
//     name = "datePicker",
//     value = null,
//     onChange = () => {},
//     onBlur = () => {},
//     requiredErrorMessage = "Please select a date.",
//     rangeErrorMessage = (minDate, maxDate) => `Please select a date between ${minDate} and ${maxDate}.`,
//     showHelp = false,
//     helpText = "Please select a date.",
//     dateRange = { minDate: null, maxDate: null },
//     validateTrigger = false
// }) => {
//     const [selectedDate, setSelectedDate] = useState(value);
//     const [errors, setErrors] = useState({});
//     const [tooltipOpen, setTooltipOpen] = useState(false);

//     // Sync value with Formik's value prop and trigger validation if needed
//     useEffect(() => {
//         setSelectedDate(value);
//     }, [value]);

//     useEffect(() => {
//         if (validateTrigger) {
//             validateDate(selectedDate);
//         }
//     }, [validateTrigger, selectedDate]);

//     // Handle date selection
//     const handleDateChange = (date) => {
//         setSelectedDate(date);
//         validateDate(date);

//         // Directly call Formik's setFieldValue through onChange
//         onChange(name, date ? format(date, "yyyy-MM-dd") : "");
//     };

//     // Handle blur event
//     const handleDateBlur = () => {
//         validateDate(selectedDate);
//         onBlur(name);
//     };

//     // Validate the date selection
//     const validateDate = (date) => {
//         const newErrors = {};

//         if (required && !date) {
//             newErrors.required = requiredErrorMessage;
//         } else if (dateRange.minDate && date < dateRange.minDate) {
//             newErrors.range = rangeErrorMessage(dateRange.minDate.toLocaleDateString(), dateRange.maxDate ? dateRange.maxDate.toLocaleDateString() : "infinity");
//         } else if (dateRange.maxDate && date > dateRange.maxDate) {
//             newErrors.range = rangeErrorMessage(dateRange.minDate ? dateRange.minDate.toLocaleDateString() : "negative infinity", dateRange.maxDate.toLocaleDateString());
//         }

//         setErrors(newErrors);
//         return Object.keys(newErrors).length === 0;
//     };

//     return (
//         <div className={`form-group ${layout === "inline" ? "d-flex align-items-center" : ""}`}>
//              <label  className="d-flex" style={{ width: layout === "inline" ? "20%" : "100%" }}>
//               <span> {label}
//                 {required && <span className="text-danger ml-1">*</span>}
//                 </span> 
//                 {showHelp && (
//                     <span id="helpTooltip" className="px-2">
//                         <i className="ri-question-line" style={{ cursor: 'pointer', fontSize: '16px' }}></i>
//                     </span>
//                 )}
//             </label>
//             {showHelp && (
//                 <Tooltip
//                     placement="right"
//                     isOpen={tooltipOpen}
//                     target="helpTooltip"
//                     toggle={() => setTooltipOpen(!tooltipOpen)}
//                 >
//                     {helpText}
//                 </Tooltip>
//             )}
//             <div className="w-100">
//                 <DatePicker
//                     showIcon
//                     selected={selectedDate}
//                     onChange={handleDateChange}
//                     onBlur={handleDateBlur}
//                     placeholderText={placeholder}
//                     minDate={dateRange.minDate}
//                     maxDate={dateRange.maxDate}
//                     isClearable
//                     className={`form-control full-width ${errors.required || errors.range ? "is-invalid" : ""}`}
//                 />
//                 {errors.required && (
//                     <FormFeedback className="d-block" type="invalid">
//                         {errors.required}
//                     </FormFeedback>
//                 )}
//                 {errors.range && (
//                     <FormFeedback className="d-block" type="invalid">
//                         {errors.range}
//                     </FormFeedback>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default DatePickerInput;
